export enum CaseSubmissionType {
  OnlineDealerWeb = '01', // DealerWeb
  ESubmission = '02', // E-submission
  Offline = '03', // 審查線下
  Unknow = '99'
}